import { FC } from "react";

const BlankProjectItem: FC = () => {
  return (
    <div
      className="aspect-video rounded-xs"
      style={{
        background: `linear-gradient(180deg, #D9D9D9 0%, #F4F5F6 100%)`,
      }}
    />
  );
};

export default BlankProjectItem;
